import Rolling from './Rolling'
import rolling from '../../assets/rolling.svg'

const Loader = ({ message }) => {
    return (
        <div className=' flex justify-center items-center flex-col gap-5 fixed top-0 left-0 w-full h-screen z-20 bg-white'>
            <Rolling src={rolling}/>
            <p>
                {message}
            </p>
        </div>
    )
}

export default Loader